// extracted by mini-css-extract-plugin
export default {"buttonContainer":"footerButtons_buttonContainer__EBZa-"};